"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step2 = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var react_device_detect_1 = require("react-device-detect");

var clsx_1 = __importDefault(require("clsx"));

var ComposedLabels_1 = require("../../components/ComposedLabels");

var ComposedTypo_1 = require("../../components/ComposedTypo");

var referenceFormatter_1 = __importDefault(require("../../utils/referenceFormatter"));

exports.Step2 = function (_a) {
  var goPreviousStep = _a.goPreviousStep,
      goToNextStep = _a.goToNextStep,
      messageError = _a.messageError,
      messagePdfError = _a.messagePdfError,
      loaderSubmit = _a.loaderSubmit,
      dataUser = _a.dataUser,
      address = _a.address,
      price = _a.price,
      pdfURL = _a.pdfURL,
      _b = _a.titulaire,
      titulaire = _b === void 0 ? "" : _b,
      mobile = _a.mobile;

  var onclick = function onclick() {
    goToNextStep();
  };

  var dataUserFormatter = function dataUserFormatter(dataUser) {
    if (!dataUser) {
      return [];
    }

    var formattedDataUser = __spread(dataUser);

    formattedDataUser[1] = referenceFormatter_1.default(formattedDataUser[1]);
    return formattedDataUser;
  };

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: "container px-md-5"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "h2",
    weight: "bold"
  }, "D\xE9tail du contrat"), react_1.default.createElement(ComposedLabels_1.ComposedLabels, {
    labels: dataUserFormatter(dataUser)
  }), react_1.default.createElement("div", {
    className: "row mb-4 mb-md-5"
  }, react_1.default.createElement("div", {
    className: clsx_1.default("col-12 col-md-6 pr-md-4 mb-md-0 mb-3")
  }, pdfURL ? react_1.default.createElement("iframe", {
    title: "Mandat pdf",
    src: pdfURL,
    width: "100%",
    height: "100%"
  }) : messagePdfError ? react_1.default.createElement("div", {
    className: "d-flex h-100"
  }, react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "danger",
    className: "justify-content-center align-self-center col-12"
  }, messagePdfError)) : react_1.default.createElement("div", {
    className: "d-flex h-100"
  }, react_1.default.createElement(react_theme_components_1.SzSpinner, {
    className: "m-auto",
    variant: "dark"
  }))), react_1.default.createElement("div", {
    className: clsx_1.default("col-12 col-md-6 pl-md-4")
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "mt-4"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, "Nom du titulaire"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, titulaire)), react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "mt-4"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, "Adresse de facturation"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, address)), react_1.default.createElement("div", {
    className: "row mt-md-5"
  }, react_1.default.createElement("div", {
    className: "col-12 col-md-6 mt-4 mt-md-0"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "mt-0 mt-md-4"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, "Solde \xE0 r\xE9gler"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, price))), react_1.default.createElement("div", {
    className: "col-12 col-md-6 mt-4 mt-md-0"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "mt-0 mt-md-4"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, "Votre n\xB0 de t\xE9l\xE9phone"), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, mobile)))))), messageError && react_1.default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "-5.5rem",
      marginRight: "-5.5rem",
      background: "var(--gray-0)",
      padding: "1rem 5.5rem"
    }
  }, react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "danger",
    className: "col-12 mb-0"
  }, messageError)), react_1.default.createElement("div", {
    className: "row position-relative justify-content-between",
    style: {
      marginLeft: "-5.5rem",
      marginRight: "-5.5rem",
      background: "var(--gray-0)",
      padding: "1rem 5.5rem",
      rowGap: "1.5rem"
    }
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    className: "col-md-6 col-lg-4 bg-transparent",
    variant: "secondary",
    icon: "arrow-left",
    onClick: goPreviousStep
  }, react_device_detect_1.isBrowser && "Étape précédente"), react_1.default.createElement(react_theme_components_1.SzButton, {
    loader: loaderSubmit,
    className: "iban-btn_submit col-md-6 col-lg-4",
    onClick: onclick
  }, "Recevoir le code confidentiel pour signer le mandat"))));
};

exports.default = exports.Step2;